export default "__VITE_ASSET__BfHPTYi4__"